import React from 'react';
import styled from '@emotion/styled';
import { ReactComponent as BackIcon } from 'Icons/back.svg';
import { Button } from "reactstrap";
import { withRouter } from 'react-router-dom';

const HeaderWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 20px;
`;

const HeaderLeft = styled.div`
  display: flex;
  align-items: center;
  gap: 16px;
`;

const StyledButton = styled(Button)`
  background-color: #597EF7;
  color: white;
  border: none;
  padding: 8px 20px;
  font-size: 14px;
  font-weight: 500;
  border-radius: 6px;

  &:hover {
    background-color: #3c5ed0;
  }

  &:focus {
    box-shadow: none;
  }
`;

const BackButton = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;
  background: none;
  border: none;
  cursor: pointer;
  padding: 8px;
  border-radius: 4px;
  transition: background-color 0.2s;

  &:hover {
    background-color: rgba(0, 0, 0, 0.05);
  }

  svg {
    width: 24px;
    height: 24px;
    path {
      fill: #597EF7;
    }
  }
`;

const Title = styled.h1`
  font-size: 24px;
  font-weight: 600;
  color: #1a1a1a;
  margin: 0;
`;

const Header = (props) => {
  const handleBack = () => {
    props.history.goBack();
  };

  const navigateToAudit = () => {
    props.history.push('/auditDashboard');
  };

  return (
    <HeaderWrapper>
      <HeaderLeft>
        <BackButton onClick={handleBack}>
          <BackIcon />
        </BackButton>
        <Title>{props.title}</Title>
      </HeaderLeft>
      <StyledButton onClick={navigateToAudit}>
        Audit
      </StyledButton>
    </HeaderWrapper>
  );
};

export default withRouter(Header);
